import { render, staticRenderFns } from "./FactoryLineDashboard.vue?vue&type=template&id=24b650e6&scoped=true&"
import script from "./FactoryLineDashboard.vue?vue&type=script&lang=js&"
export * from "./FactoryLineDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FactoryLineDashboard.vue?vue&type=style&index=0&id=24b650e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b650e6",
  null
  
)

export default component.exports